import styled from 'styled-components';

// style
export const Wrapper = styled.div`
	width: 100%;
   background: transparent;
	margin: 0 auto;
	position: relative;
   padding: 0 112px;
    @media (max-width: 1400px) {
       padding: 0 70px;
    }
    @media (max-width: 1200px) {
       padding: 0 40px;
    }
    @media (max-width: 1000px) {
       padding: 0 30px;
    }
    @media (max-width: 900px) {
       padding: 0 20px;
    }
`;
